// extracted by mini-css-extract-plugin
module.exports = {"SunTimesHeader":"Header_SunTimesHeader__12GFT","Logo":"Header_Logo__OkEFZ","Star":"Header_Star__3OgOk","nav":"Header_nav__pDiLB","Social":"Header_Social__l-8Jp"};